import { Form } from "../Support/Form";
import { axios } from "../Support/axios";

export class Processor extends Form {

    constructor(data = {}) {
        super(data);

        this.data.driver = null;
        this.data.tenant_name = null;

        this.processor = false;
        this.processors = false;

        this.drivers = false;
        this.tenants = false;
    }

    processorsAvailable() {
        if (this.processors && this.processors.data) {
            return this.processors.data.length > 0;
        }

        return false;
    }

    getDrivers() {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get('/api/processor/driver', self.data)
                .then(response => {

                    self.drivers = response.data;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

    getTenants() {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get('/api/tenant', self.data)
                .then(response => {
                    self.tenants = response.data;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

    index() {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get('/api/processor', self.data)
                .then(response => {

                    self.processors = response.data;

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

    list() {
        let self = this;

        return new Promise((resolve, reject) => {
            axios.get('/api/processor/list', self.data)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    self.setError(error);
                    reject(error);
                });
        });
    }

    createProcessor() {
        let self = this;

        self.resetFormMessages().then(result => {
            self.setFormUpdating();
        });

        return new Promise((resolve, reject) => {
            axios.post('/api/processor', self.data)
                .then(response => {
                    self.setSuccessMessage('Processor Created')
                    self.setFormUpdateComplete();

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);

                    reject(error);
                })
        });
    }

    edit(processor) {
        let self = this;

        return new Promise((resolve, reject) => {
            self.getTenants().then(result => {
                self.getDrivers().then(result => {
                    axios.get('/api/processor/' + processor, self.data)
                        .then(response => {
                            this.data = response.data.data;

                            resolve(true);
                        })
                        .catch(error => {
                            self.setError(error);

                            reject(error);
                        })
                });
            });
        });
    }

    updateProcessor(processor) {
        let self = this;

        self.resetFormMessages().then(result => {
            self.setFormUpdating();
        });

        return new Promise((resolve, reject) => {
            axios.patch('/api/processor/' + processor, self.data)
                .then(response => {
                    this.data = response.data.data;

                    self.setSuccessMessage('Updated Processor.')
                    self.setFormUpdateComplete();

                    resolve(true);
                })
                .catch(error => {
                    self.setError(error);

                    reject(error);
                })
        });

    }

}
